import React from 'react';
import { Shield, Lock, Eye, FileCheck } from "lucide-react";

export default function Safety() {
  return (
    <section id="safety" className="py-24 bg-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-secondary font-bold tracking-wider uppercase text-sm">Safety First</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4 mb-6">Uncompromised Security Standards</h2>
          <p className="text-white/70 text-lg">
            We treat employee safety as our single most critical metric. Our multi-layered security protocol ensures peace of mind for every ride.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: Shield,
              title: "Vetted Drivers",
              desc: "Rigorous background checks, police verification, and behavioral training for every driver."
            },
            {
              icon: Eye,
              title: "24/7 Command Center",
              desc: "Real-time monitoring of every trip. We detect route deviations and over-speeding instantly."
            },
            {
              icon: Lock,
              title: "SOS & Panic Button",
              desc: "In-app emergency triggers that alert our response team and nearest police station immediately."
            },
            {
              icon: FileCheck,
              title: "Compliance Audit",
              desc: "100% adherence to statutory vehicle norms, insurance, and fitness certificates."
            }
          ].map((item, idx) => (
            <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300">
              <item.icon className="h-10 w-10 text-secondary mb-6" />
              <h3 className="text-xl font-bold mb-3">{item.title}</h3>
              <p className="text-white/60 leading-relaxed text-sm">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 p-8 bg-secondary/10 rounded-3xl border border-secondary/20 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className="h-20 w-20 rounded-full bg-green-500/20 flex items-center justify-center animate-pulse">
              <Shield className="h-10 w-10 text-green-400" />
            </div>
            <div>
              <h3 className="text-2xl font-bold">Female Employee Safety</h3>
              <p className="text-white/70 max-w-md mt-2">
                Special protocols for late-night drops including escort guards and "last-drop" confirmation calls.
              </p>
            </div>
          </div>
          <div className="flex gap-4">
             <div className="px-6 py-3 bg-white/10 rounded-lg text-center">
                <div className="text-2xl font-bold text-secondary">0</div>
                <div className="text-xs text-white/60 uppercase tracking-wider">Incidents</div>
             </div>
             <div className="px-6 py-3 bg-white/10 rounded-lg text-center">
                <div className="text-2xl font-bold text-secondary">100%</div>
                <div className="text-xs text-white/60 uppercase tracking-wider">Safe Drops</div>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
}
